<template>
  <div class="hot_rank" v-if="hostList.length">
    <div class="hr_title">热榜排行</div>
    <div class="hr_con">
      <div class="hr_item two" @click="link(hostList[1])">
        <template v-if="hostList[1]">
          <i class="one_icon iconfont icon-huangguan1"></i>
          <img :src="hostList[1].targetInfo.logo">
          <p>{{hostList[1].targetInfo.name}}</p>
        </template>
      </div>
      <div class="hr_item one" @click="link(hostList[0])">
        <template v-if="hostList[0]">
          <div class="one_img">
            <i class="one_icon iconfont icon-huangguan2"></i>
            <img class="comp_img" :src="hostList[0].targetInfo.logo">
          </div>
          <p>{{hostList[0].targetInfo.name}}</p>
        </template>
      </div>
      <div class="hr_item three" @click="link(hostList[2])">
        <template v-if="hostList[2]">
          <i class="one_icon iconfont icon-huangguan1"></i>
          <img :src="hostList[2].targetInfo.logo">
          <p>{{hostList[2].targetInfo.name}}</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  // 热榜
  name: "hot-rank",
  data() {
    return { 
      hostList:[],
    };
  },
  components: {
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userId: "getUserId",
      roomId:"getRoomid",
      userInfo:'getUserInfo'
    }),
    option() {
      return {
        roomId: this.roomId,
      };
    }
  },
  created(){
    if(this.roomId){
      this.init();
    }
  },
  methods: {
    ...mapActions({
      getHotRankTop:'company/getHotRankTop',
      LinkProduct:'linkTo/LinkProduct',
      LinkCompany:'linkTo/LinkCompany',
      LinkExhibitionDetails:'linkTo/LinkExhibitionDetails'
    }),
    async init(){
      let list = await this.getHotRankTop(this.option);
      list.map(c =>{
        if(c.targetInfo){
          c.targetInfo = JSON.parse(c.targetInfo)
        }
      })
      this.hostList = list;
    },
    link(item){
      if(this.userInfo.userRole == 0) {
        this.$toast('请前往注册');
        return;
      }
      if(item.typeId === 1) { // 展品
        this.LinkProduct(item.targetId);
      }
      if(item.typeId === 0) { // 展商公司
        this.LinkExhibitionDetails(item.targetId);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.hot_rank{
  height: 3.2rem;
  width: calc(100% - 0.4rem);
  z-index: 102;
  top: 4.43rem;
  left: 0.2rem;
  overflow: hidden;
  border-radius: 0.07rem;
  position: absolute;
  background: #fff;
  .hr_title{
    background: url("../../assets/img/hot_rank_title.jpg");
    background-size: 100% 100%;
    height: 0.9rem;
    line-height: 0.9rem;
    text-align: center;
    color: #fff;
    font-size: 0.3rem;
  }
  .hr_con{
    padding:0.4rem  0.4rem 0;
    display: flex;
    justify-content: space-between;
    position: relative;
    
    .hr_item{
      width: 1.8rem;
      text-align: center;
      position: relative;
      .one_icon{
        border-radius: 0;
        font-size: 0.40rem;
        border: none;
        margin: 0;
        position: absolute; 
        left: 50%;
        top: -0.34rem;
        z-index: 2;
        transform: translateX(-50%);
        display: inline-block;
        -webkit-background-clip:text;
        color: transparent;
      }
      &.one{
        width: 2.65rem;
        height: 1.9rem;
        background: url("../../assets/img/tixingbg.png");
        background-size: 100% 100%;
        position: relative;
        top: -0.61rem;
        border-radius: 0.09rem 0.09rem 0 0;
        text-align: center;
        .one_img{
          position: relative;
          z-index: 2;
          width:1.2rem;
          height: 1.2rem;
          margin: 0.4rem auto 0;
          display: block;
          margin-bottom: 0.2rem;
          .one_icon{
            background-image: linear-gradient(to right,#fddf84,#fbcd42);
            font-size: 0.6rem;
            top: -0.49rem;
          }
          .comp_img{
            border-color:#ffe26d;
          }
        }
      }
      &.two{
        .one_icon{
          background-image: linear-gradient(to right,#eef2f3,#8e9eab);
        }
        img{
          border-color:#bec8cf;
        }
      }
      &.three{
        .one_icon{
            background-image: linear-gradient(to right,#e29587,#d66d75);
          }
        img{
          border-color:#dc817e;
        }
      }
      img{
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 0.03rem;
        border:1px solid #f2f2f2 ;
        // object-fit: cover;
        margin-bottom: 0.1rem;
      }
      p{
        display: block;
        font-size: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

</style>
